import(/* webpackMode: "eager", webpackExports: ["ProtectedRoute"] */ "/opt/buildhome/repo/packages/shared/src/components/common/auth/ProtectedRoute.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNavbar"] */ "/opt/buildhome/repo/packages/shared/src/components/shared/BottomNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/opt/buildhome/repo/packages/shared/src/components/shared/Sidebar.tsx");
